const conductAlternatives = {
  Destructive: 1,
  Inappropiate: 2
};
export default conductAlternatives;
